import SparkMD5 from "spark-md5"

let vm
export default {
  name: "ResourceUploader",
  components: {

  },
  props: {
    parentId: Number,
    catalogPath: Array
  },
  beforeCreate() {
    vm = this
  },
  data() {
    return {
      uploaderFiles: {}, // 上传的文件列表
      uploadingFlag: true, // 有文件上传中标识
      uploadErrorFlag: false, // 有文件上传失败标识
      totalProgress: 0, // 上传列表总进度
      totalFileError: {}, // 正在上传文件出现被删除、被转移等错误
      speedFlag: 0, // 用于vue重新渲染速度
      uuid: '', // 用于分片文件存储的文件夹名称
      sizeLimit: 1024 * 1024 * 1024, // 上传文件大小限制
      filePathIds: {}, // 当前文件所在层级id（上传用）
      // 上传组件
      options: {
        target: '/resapi/resource/uploader/fileUpload',
        simultaneousUploads: 3, // 并发上传数
        chunkSize: 512 * 1024, // 0.5M一个分片
        forceChunkSize: true, // 不允许最后一片大于分片大小
        fileParameterName: 'file', // 上传文件时文件的参数名，默认 file
        headers: {
          authorization: localStorage.getItem('rs_t')
        }, // 请求头
        maxChunkRetries: 30, // 最大自动失败重试上传次数，值可以是任意正整数，如果是 undefined 则代表无限次，默认 0。
        chunkRetryInterval: 1000, // 每次重试间隔（正整数，单位毫秒）
        testChunks: true,   //是否开启服务器分片校验
        permanentErrors: [404, 415, 500, 501, 503, 801, 802, 805],
        // 服务器分片校验函数，秒传及断点续传基础
        checkChunkUploadedByResponse: function (chunk, resp) {
          // 如果所有分片后端都存在的话则直接会跳到onFileSuccess方法并且携带resp数据
          //校验接口返回之后，可以暂停
          vm.$set(chunk.file, "canPause", true)
          //设置为false后，文件状态就根据组件状态显示
          vm.$set(chunk.file, "waitUpload", false)
          // if(vm.nextUploadFile !== null && vm.nextUploadFile.id !== chunk.file.id) {
          //   vm.$set(vm.nextUploadFile, "canPause", false)
          // }
          const result = JSON.parse(resp)
          if (result.success) {
            vm.fileUUID[chunk.file.id] = result.data.uuid
            return result.data.whetherToSkip
          }
        },
        // 处理请求参数
        processParams: function (params, file) {
          params.pathId = vm.filePathIds[file.id]
          if (vm.fileUUID[file.id] !== undefined) {
            params.uuid = vm.fileUUID[file.id]
          }else {
            //第一次请求校验接口，设置不可暂停
            vm.$set(file, "canPause", false)
          }
          return params
        },
        generateUniqueIdentifier: function (file) {
          var relativePath = file.relativePath || file.webkitRelativePath || file.fileName || file.name;
          var r = Math.round(Math.random() * 100000000);
          return r + "-" + file.size + '-' + relativePath.replace(/[^0-9a-zA-Z_-]/img, '');
        }
      },
      nextUploadFile: null, // 下一个上传的文件
      filesMerge: {}, // 存放文件合并的状态(key:id)
      filesMergeError: {}, // 存放文件合并失败的状态(key:id)
      filesSuccess: {}, //文件上传成功(key:id)
      filesMD5: {}, // 存放文件计算md5的状态(key:id)
      fileUUID: {}, // 存放文件的uuid(key:id)
      filePause: {}, // 存放文件暂停的状态(key:id)
      fileSurpassSize: {}, // 存放超过上传大小的文件
      fileSuccessTime: {}, // 存放文件上传成功时间点(key:id)
      dropVisible: false, // 拖动上传区域展示标识
      panelShow: false, // 选择文件后，右下角展示上传列表
      collapse: false, // 上传列表展示后缩放(true.展开 false.折叠)
      filePath: {}, // 文件合并后保存父级目录id
      capacityIsFull: false, // 容量空间已满标识,
      loginFailure: false, // 登录失效,
      overDirFileLimit: false, // 超过文件上限,
      overFileSize: false, // 超过文件大小,
      uploadErrorNum: {
        full: 0,
        loginFail: 0,
        overDirFileLimit: 0,
        overFileSize: 0,
      },
      startDragEle: null,
    };
  },
  created() {
  },
  watch: {

  },
  mounted() {
    const oDragWrap = document.body

    let lastEnterEle = null
    // 开始拖动
    oDragWrap.addEventListener(
        "dragstart",
        function (e) {
          console.log("开始拖动", e)
          vm.startDragEle = e.target;
        },
        false
    )
    // 拖进
    oDragWrap.addEventListener(
        "dragenter",
        function (e) {
          if (vm.startDragEle != null){
            return;
          }
          console.log("拖进", e)
          e.preventDefault()
          lastEnterEle = e.target
          vm.dropVisible = true
        },
        false
    )

    // 拖离
    oDragWrap.addEventListener(
        "dragleave",
        function (e) {
          if (vm.startDragEle != null){
            return;
          }
          console.log("拖离", e)
          if (lastEnterEle === e.target) {
            vm.dropVisible = false
          }
        },
        false
    )

    //拖来拖去,一定要注意dragover事件一定要清除默认事件不然会无法触发后面的drop事件
    oDragWrap.addEventListener(
        "dragover",
        function (e) {
          if (vm.startDragEle != null){
            return;
          }
          // console.log("拖来拖去", e, new Date())
          e.preventDefault()
        },
        false
    )

    // 放
    oDragWrap.addEventListener(
        "drop",
        function (e) {
          console.log("放", e)
          e.stopPropagation()
          vm.dropVisible = false;
          vm.startDragEle = null;
        },
        false
    )
  },
  computed: {
    // 初始化uploader实例
    uploader() {
      return vm.$refs.uploader.uploader
    },
    catalogPathComp() {
      return this.catalogPath.filter(function (data, index) {
        data.realIndex = index;
        return index != 0 && (vm.catalogPath.length <= 4 || index > (vm.catalogPath.length - 4));
      })
    }
  },
  filters: {
    // 获取文件上传状态
    getUploadStatus(flag, status, speed, file, props) {
      //console.log("props", props)
      let statusText = ''
      // 如果文件在暂停状态，并且正在计算md5则状态显示为‘计算md5’
      if (props.response && props.response.data && props.response.data.overDirFileLimit && props.response.data.overFileSize){
        statusText = '上传失败'
        props.status = "error";
      } else if (status === 'paused' && vm.filePause[file.id]) {
        statusText = '暂停中'
      } else if (status === 'paused' && Object.prototype.hasOwnProperty.call(vm.filesMD5, file.id) && vm.filesMD5[file.id]) {
        statusText = '文件扫描中'
      } else if (status === 'paused') {
        if (file.waitUpload === true){
          //第一个校验接口期间显示等待上传…
          statusText = '等待上传…'
        }else {
          statusText = '暂停中'
        }
      } else if (status === 'waiting') {
        statusText = '等待上传…'
      } else if (status === 'uploading') {
        let kb = speed / 1024
        if (vm.totalFileError[file.id]) {
          kb = 0
        }
        // 正在上传开始计算上传速度
        if (kb < 1024) {
          // 如果小于1mb的话展示kb为单位的速度即可
          statusText = parseInt(kb) + 'KB/s'
        } else {
          const mb = kb / 1024
          statusText = Math.round(mb) + 'MB/s'
        }
      } else if (status === 'error' || vm.filesMergeError[file.id]) {
        statusText = '上传失败'
      } else if (status === 'success') {
        if (vm.filesMerge[file.id]){
          statusText = '正在解析…'
        } else {
          if(Object.prototype.hasOwnProperty.call(vm.fileSuccessTime, file.id)) {
            statusText = vm.fileSuccessTime[file.id]
          }else {
            statusText = vm.getDay()
          }
          statusText = vm.fileSuccessTime[file.id]
        }
      }
      return statusText
    },
    // 格式化剩余时间
    getRemainingTime(sec, file) {
      if (file.paused || sec === Number.POSITIVE_INFINITY || sec === 0) {
        return ''
      }

      let h = Math.floor(sec / 3600)
      let m = Math.floor((sec / 60 % 60))
      let s = Math.floor((sec % 60))

      if (h < 10) {
        h = '0' + h
      }
      if (m < 10) {
        m = '0' + m
      }
      if (s < 10) {
        s = '0' + s
      }

      return h + ':' + m + ':' + s
    },
    // 获取各文件状态数量
    getNum(speedFlag, uploaderFiles, status) {
      let num = 0
      for (const key in uploaderFiles) {
        const value = uploaderFiles[key]
        if (value[status]) {
          num++
        }
      }
      vm.uploadErrorNum[status] = num;
      return num
    }
  },
  methods: {
    resetParentId(newParentId) {
      this.$emit('resetParentId', newParentId)
    },
    queryFiles(showLoading){
      this.$emit('queryFiles', showLoading)
    },
    refreshFiles(params){
      this.$emit('refreshFiles', params)
    },
    toRootDir() {
      this.$emit('toRootDir')
    },
    // 去文件所在目录
    toDirectory(file) {
      this.$emit('toDirectory', file)
    },
    // 多个文件的校验
    onFilesAdded(files) {
      console.log("多个文件的校验 file size", files.length)
      // 先校验文件数量是否小于300
      const fileList = vm.$refs.uploader.uploader.fileList
      let uploadingFileNum = 0
      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i]
        if (!file.isComplete() && !file.error) {
          uploadingFileNum++
        }
      }
      if (files.length > 300) {
        files.ignored = true
        vm.$message('请不要同时上传超过300个文件', 2000, {showClose: true, type: 'warning'})
        return false
      }
      let sizeLimitNum = 0
      // 再校验文件夹层级
      for (let i = files.length - 1; i > -1; i--) {
        let suffix = "";
        if (files[i].name.indexOf(".") > -1){
          suffix = files[i].name.substring(files[i].name.lastIndexOf(".") + 1);
        }

        const filePaths = files[i].relativePath.split('/')
        if (filePaths.length - 1 + vm.catalogPath.length > 20) {
          vm.$message('文件夹层级最大支持20级', 2000, {showClose: true, type: 'error'})
          files.splice(0, files.length)
          return false
        }
        // 单文件大小最大不能超过限制
        if (this.surpassFileSize(suffix, files[i].size)) {
          console.log("多个文件的校验 单文件大小最大不能超过限制")
          sizeLimitNum++
          // files.splice(i, 1)
        }
      }
      console.log("多个文件的校验 sizeLimitNum", sizeLimitNum)
      if (sizeLimitNum > 0 && sizeLimitNum == files.length) {
        vm.$message(sizeLimitNum + '个文件上传失败，文档不能超出100M，其他文件不能超出1G，请拆分上传', 3000, {showClose: true, type: 'error'});
        files.splice(0, files.length)
        return;
      }
      //添加文件后重新获取一次token
      vm.options.headers.authorization = localStorage.getItem('rs_t');
      // 有允许上传的文件
      if (files.length > 0) {
        vm.bubbleSort(files) // 冒泡排序，小文件先上传
        vm.panelShow = true // 展开上传文件列表
        vm.collapse = false
        // vm.$set(files[0], "canPause", false)
        vm.nextUploadFile = files.length > 1 ? files[1] : null
        // 校验通过再开始计算md5
        for (let i = 0; i < files.length; i++) {
          const file = files[i]
          vm.uploaderFiles[file.id] = {
            uploading: true,
            success: false,
            error: false,
          }
          vm.filePathIds[file.id] = vm.parentId === null ? 0 : vm.parentId
          vm.computeMD5(file) // 开始计算文件md5
        }
        vm.getFileListStatus()
      }
    },
    // 获取上传进度
    onFileProgress(rootFile, file) {
      vm.speedFlag = vm.speedFlag > 10000 ? 0 : (vm.speedFlag + 1)
      vm.totalFileError[file.id] = false
      // 获取所有文件列表的进度
      let total = 0
      const fileList = vm.$refs.uploader.uploader.files
      for (let i = 0; i < fileList.length; i++) {
        total += fileList[i].progress()
      }
      let uploadingFileNum = 0;
      for (const key in vm.uploaderFiles) {
        const value = vm.uploaderFiles[key]
        if (value.uploading || value.success) {
          uploadingFileNum++
        }
      }
      vm.totalProgress = uploadingFileNum === 0 ? 0 : Math.round(total / uploadingFileNum * 100)
      vm.totalProgress = vm.totalProgress > 100 ? 100 : vm.totalProgress
    },
    // 文件重试上传事件(将重试中的文件速度置为0KB/s)
    onFileRetry(rootFile, file) {
      vm.speedFlag++
      vm.totalFileError[file.id] = true
    },
    // 上传成功
    onFileSuccess(rootFile, file, resp) {
      const arr = Object.keys(vm.uploaderFiles)
      if(arr.length === 0) {
        return
      }
      let res = JSON.parse(resp)
      console.log(file.id + '文件上传完毕', resp)
      if (!res.success){
        vm.uploaderFiles[file.id] = {
          uploading: false,
          success: false,
          error: true
        }
        vm.filesSuccess[file.id] = false
        vm.filesMerge[file.id] = false
        vm.filesMergeError[file.id] = true
        vm.getFileListStatus()
        return
      }
      if(vm.filesSuccess[file.id]){
        return;
      }else{
        vm.filesSuccess[file.id] = true;
      }
      let data = res.data;
      vm.filesMergeError[file.id] = false;
      vm.filesMerge[file.id] = true;
      if (data.needMerge){
        // 最后一片上传成功直接发起合并请求
        vm.mergeChunks(file)
      }else {
        if (data.uploadDirIsDel){
          vm.$message.info("文件夹位置异常，已保存在根目录下")
        }
        vm.uploaderFiles[file.id] = {
          uploading: false,
          success: true,
          error: false
        }
        vm.filesMerge[file.id] = false;
        vm.filePath[file.id] = data.parentId
        vm.$set(file, "parentId", data.parentId)
        vm.getFileListStatus();
        vm.queryFiles(false)
        vm.fileSuccessTime[file.id] = vm.getDay()
      }
    },
    // 上传失败
    onFileError(rootFile, file, resp) {
      vm.$refs['file_' + file.id][0]._fileError();
      if (Object.prototype.hasOwnProperty.call(vm.uploaderFiles, file.id)) {
        vm.uploaderFiles[file.id] = {
          uploading: false,
          success: false,
          error: true
        }
      }
      console.log("上传失败", resp)
      if (resp !== '') {
        const result = JSON.parse(resp)
        if (!result.success && result.errorCode == -503){
          vm.loginFailure = true;
          vm.uploaderFiles[file.id].loginFail = true
        }else if (result.data.capacityIsFull) {
          vm.capacityIsFull = true;
          vm.uploaderFiles[file.id].full = true
          vm.$message.error(result.data.message)
        }else if (result.data.overDirFileLimit) {
          vm.overDirFileLimit = true;
          vm.uploaderFiles[file.id].overDirFileLimit = true;
        }else if (result.data.overFileSize) {
          vm.overFileSize = true;
          vm.uploaderFiles[file.id].overFileSize = true;
        }

      }
      vm.getFileListStatus()
    },
    // 文件上传完毕
    onComplete() {
      console.log('上传完毕')
    },
    // 获取文件列表展示状态
    getFileListStatus() {
      let uploadingFlag = false
      for (const key in vm.filesMD5) {
        const value = vm.filesMD5[key]
        if (value) {
          uploadingFlag = true
        }
      }
      let flag = false
      for (const key in vm.uploaderFiles) {
        const value = vm.uploaderFiles[key]
        if (value.uploading) {
          uploadingFlag = true
        }
        if (value.error) {
          flag = true
        }
      }
      vm.uploadingFlag = uploadingFlag
      vm.uploadErrorFlag = flag
    },
    // 合并文件块
    mergeChunks(file) {
      console.log('mergeChunks' + file.id, vm.uploaderFiles[file.id]);
      vm.$api.post("/resapi/resource/uploader/mergeFile",
          {
            filename: file.name,
            identifier: file.uniqueIdentifier,
            relativePath: file.relativePath,
            totalSize: file.size,
            uuid: vm.fileUUID[file.id],
            pathId: vm.filePathIds[file.id]
          },
          {timeout:600000}
      ).then(res => {
        if (!res.success) {
          vm.filesSuccess[file.id] = false;
          vm.uploaderFiles[file.id] = {
            uploading: false,
            success: false,
            error: true
          }
          vm.filesMergeError[file.id] = true;
          if (res.errorCode == 802){
            vm.overDirFileLimit = true;
            vm.uploaderFiles[file.id].overDirFileLimit = true;
          }else if (res.errorCode == 805){
            vm.overFileSize = true;
            vm.uploaderFiles[file.id].overFileSize = true;
          }else if (res.errorCode == 801){
            vm.capacityIsFull = true;
            vm.uploaderFiles[file.id].full = true;
          }else {
            vm.$message.error(res.info)
          }
          vm.$refs['file_' + file.id][0]._fileError();
          vm.filesMerge[file.id] = false;
          vm.getFileListStatus();
          vm.queryFiles(false);
          vm.speedFlag ++;
        } else {
          if(res.data.threadMerge){
            //后台使用线程合并
            vm.uploaderFiles[file.id] = {
              uploading: true,
              success: false,
              error: false
            }
            vm.getFileListStatus();
            vm.queryFiles(false)
            //合并结果查询
            vm.timeOutMergeQuery({uuid: vm.fileUUID[file.id], id : file.id});
            return;
          }
          if (res.data.uploadDirIsDel){
            vm.$message.info("文件夹位置异常，已保存在根目录下")
          }
          vm.uploaderFiles[file.id] = {
            uploading: false,
            success: true,
            error: false
          }
          vm.filePath[file.id] = res.data.parentId
          vm.$set(file, "parentId", res.data.parentId)
          vm.filesMerge[file.id] = false;
          vm.$refs['file_' + file.id][0]._fileSuccess();
          vm.fileSuccessTime[file.id] = vm.getDay()
          vm.getFileListStatus();
          vm.queryFiles(false);
          vm.speedFlag ++;
        }

      }).catch(error => {
        console.log(file.id + "merge fail", error)
        vm.filesSuccess[file.id] = false;
        vm.uploaderFiles[file.id] = {
          uploading: false,
          success: false,
          error: true
        }
        vm.filesMergeError[file.id] = true;
        vm.$refs['file_' + file.id][0]._fileError();
        vm.getFileListStatus();
        vm.speedFlag ++;
      })
    },
    timeOutMergeQuery(fileObject){
      setTimeout(function (){
        vm.queryThreadMergeResult(fileObject)
      }, 3000);
    },
    queryThreadMergeResult (item){
      this.$api.post("/resapi/resource/uploader/mergeResult", {uuid: item.uuid}).then(res => {
        if (!res.success) {
          vm.timeOutMergeQuery(item);
          return console.log(res.info);
        }
        if(res.data.mergeStatus == '0'){
          //合并结果查询
          vm.timeOutMergeQuery(item);
          return;
        }else if(res.data.mergeStatus == '1'){
          console.log(item.id + "merge success")
          if (res.data.dirDel && res.data.dirDel == 'true'){
            vm.$message.info("文件夹位置异常，已保存在根目录下")
          }
          vm.uploaderFiles[item.id] = {
            uploading: false,
            success: true,
            error: false
          }
          vm.filePath[item.id] = res.data.parentId
          vm.$set(item, "parentId", res.data.parentId)
          vm.filesMerge[item.id] = false;
          vm.$refs['file_' + item.id][0]._fileSuccess();
          vm.fileSuccessTime[item.id] = vm.getDay()
          vm.getFileListStatus();
          vm.queryFiles(false)
          vm.speedFlag++
        }else{
          vm.filesSuccess[item.id] = false;
          vm.uploaderFiles[item.id] = {
            uploading: false,
            success: false,
            error: true
          }
          vm.filesMergeError[item.id] = true;
          if (res.data.mergeStatus == '3'){
            vm.overDirFileLimit = true;
            vm.uploaderFiles[item.id].overDirFileLimit = true;
          }else if (res.data.mergeStatus == '4'){
            vm.capacityIsFull = true;
            vm.uploaderFiles[item.id].full = true;
          }else if (res.data.mergeStatus == '5'){
            vm.overFileSize = true;
            vm.uploaderFiles[item.id].overFileSize = true;
          }
          vm.$refs['file_' + item.id][0]._fileError();
          vm.filesMerge[item.id] = false;
          vm.getFileListStatus();
          vm.queryFiles(false)
          vm.speedFlag++
        }
      }).catch(res => {
        console.log(res)
        vm.filesSuccess[item.id] = false;
        vm.uploaderFiles[item.id] = {
          uploading: false,
          success: false,
          error: true
        }
        vm.filesMergeError[item.id] = true;
        vm.$refs['file_' + item.id][0]._fileError();
        vm.getFileListStatus();
        vm.speedFlag++
      })
    },
    // 关闭上传文件列表，并终止上传
    close() {
      if (vm.uploadingFlag || vm.uploadErrorFlag) {
        // 二级弹窗确认
        vm.$confirm('关闭上传窗口，未上传完的任务将清除', '结束上传', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          action()
        })
      } else {
        action()
      }

      function action() {
        // 终止上传操作
        vm.uploader.cancel()
        // 关闭文件上传列表
        vm.panelShow = false
        // 重置上传文件数据
        vm.uploaderFiles = {}
        vm.uploadingFlag = true
        vm.uploadErrorFlag = false
        // 重置总上传进度
        vm.totalProgress = 0
        // 重置容量已满提示
        vm.capacityIsFull = false
        vm.loginFailure = false;
        vm.overDirFileLimit = false;
        vm.overFileSize = false;
      }
    },
    // 计算文件md5签名
    computeMD5(file) {
      let fileReader = new FileReader()
      let time = new Date().getTime()
      let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
      let currentChunk = 0
      const chunkSize =  4 * 1024 * 1024 // 计算大文件md5时分片大小
      let chunks = Math.ceil(file.size / chunkSize)
      let spark = new SparkMD5.ArrayBuffer()
      vm.filesMD5[file.id] = true // 将文件状态改成‘计算md5’

      // 可以将文件状态改为计算md5
      file.pause()
      loadNext()

      fileReader.onload = (e => {
        let suffix = "";
        if (file.name.indexOf(".") > -1){
          suffix = file.name.substring(file.name.lastIndexOf(".") + 1);
        }
        if (this.surpassFileSize(suffix, file.size)) {
          vm.fileSurpassSize[file.id] = true;
          vm.filesSuccess[file.id] = false;
          vm.filesMD5[file.id] = false;
          vm.$set(file, "md5Success", true)
          vm.$refs['file_' + file.id][0]._fileError();
          if (Object.prototype.hasOwnProperty.call(vm.uploaderFiles, file.id)) {
            vm.uploaderFiles[file.id] = {
              uploading: false,
              success: false,
              error: true
            }
          }
          vm.overFileSize = true;
          vm.uploaderFiles[file.id].overFileSize = true;
          vm.getFileListStatus()
          vm.speedFlag ++;
          return;
        }

        spark.append(e.target.result)

        if (currentChunk < chunks) {
          currentChunk++
          loadNext()
        } else {
          let md5 = spark.end()
          vm.computeMD5Success(md5, file)
          console.log(`MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${file.size} 用时：${new Date().getTime() - time} ms`)
        }
      })

      fileReader.onerror = function () {
        console.log(`文件${file.name}读取出错，请检查该文件`)
        // file.cancel()
        vm.filesMD5[file.id] = false;
        vm.$refs['file_' + file.id][0]._fileError();
        vm.uploaderFiles[file.id] = {
          uploading: false,
          success: false,
          error: true
        }
        vm.getFileListStatus()
      }

      function loadNext() {
        let start = currentChunk * chunkSize
        let end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize

        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end))
      }
    },
    // 文件计算md5成功
    computeMD5Success(md5, file) {
      file.uniqueIdentifier = md5
      // 将文件状态取消‘计算md5’
      vm.filesMD5[file.id] = false
      if (Object.prototype.hasOwnProperty.call(vm.filePause, file.id) && vm.filePause[file.id]) {
        file.pause()
      } else {
        file.resume()
      }
      //可能md5计算会在获取第一个请求参数之后，所以需要判断是否为undefined
      if (file.canPause === undefined){
        vm.$set(file, "canPause", true)
      }
      vm.$set(file, "md5Success", true)
      //md5计算完成之后，就变成等待上传状态，校验接口返回后，按组件状态显示
      vm.$set(file, "waitUpload", true)
    },
    // 文件上传列表‘开始’按钮点击
    uploadStart(file, status) {
      console.log(status)
      vm.$refs['file_' + file.id][0].resume()
      vm.getNextUploadFile()
    },
    // 单个文件操作按钮
    fileControl(func, file) {
      switch (func) {
        case 'cancel': {
          delete vm.uploaderFiles[file.id]
          delete vm.filesMD5[file.id]
          vm.uploaderCancel(vm.fileUUID[file.id])
          vm.getFileListStatus()
          break
        }
        case 'retry' : {
          vm.uploaderFiles[file.id] = {
            uploading: true,
            success: false,
            error: false
          }
          if(!vm.filesMergeError[file.id]){
            vm.filesMD5[file.id] = false
            vm.filesMerge[file.id] = false;
            vm.getFileListStatus();
          }
          break
        }
      }
      if (func === 'pause') {
        if (!file.canPause){
          vm.$message.error("正在创建文件，不能暂停")
          return
        }
        //点击过一次暂停后，文件状态根据组件显示
        file.waitUpload = false;
        vm.$refs['file_' + file.id][0].pause();
      } else if(func === 'retry' && vm.filesMergeError[file.id] && vm.filesMerge[file.id]) {
        vm.ucloading.showLoading();
        vm.filesMergeError[file.id] = false;
        vm.filesMerge[file.id] = true;
        vm.getFileListStatus();
        vm.$refs['file_' + file.id][0]._fileSuccess();
        vm.mergeChunks(file);
        vm.ucloading.hideLoading();
      } else {
        file[func]()
      }
      vm.getNextUploadFile()
    },
    // 获取下一个上传的文件
    getNextUploadFile() {
      vm.nextUploadFile = null
      const files = vm.$refs.uploader.uploader.files
      let flag = false
      let ids = []
      for (let i = 0; i < files.length; i++) {
        const f = files[i]
        // 已经上传完毕的忽略
        if(f.isComplete()) {
          continue
        }else if(!f.paused && !f.error) {
          // 不在暂停状态且未失败
          vm.nextUploadFile = f
          flag = true
          break
        }else{
          ids.push(i)
        }
      }
      if(!flag && ids.length > 0) {
        vm.nextUploadFile = files[ids[0]]
      }
    },
    // 取消上传
    uploaderCancel(uuid) {
      this.$api.get(
          "/resapi/resource/uploader/uploaderCancel",
          {
            params: {
              uuid: uuid
            }
          }
      ).catch(error => {
        console.error(error);
      })
    },
    // 文件列表‘全部开始’
    allFilesResume() {
      const fileList = vm.$refs.uploader.uploader.files
      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i]
        vm.filePause[file.id] = false
      }
      vm.$refs.uploader.uploader.resume()
    },
    // 文件列表‘全部暂停’
    allFilesPause() {
      const fileList = vm.$refs.uploader.uploader.files
      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i]
        if (!file.completed) {
          vm.$refs['file_' + file.id][0].pause();
          vm.filePause[file.id] = true
        }
      }
      vm.$refs.uploader.uploader.pause()
    },
    // 文件列表‘全部取消’
    allFilesCancel() {
      const fileList = vm.$refs.uploader.uploader.files
      for (let i = fileList.length - 1; i > -1; i--) {
        const file = fileList[i]
        if (!file.completed) {
          file.cancel()
          delete vm.uploaderFiles[file.id]
          delete vm.filesMD5[file.id]
          vm.getFileListStatus()
        }
      }
      vm.uploadingFlag = false
    },
    // 获取当前日期
    getDay() {
      const d = new Date()
      const seperator = ":"
      const hour = change(d.getHours())
      const minute = change(d.getMinutes())
      const second = change(d.getSeconds())

      function change(t) {
        if (t < 10) {
          return "0" + t
        } else {
          return t
        }
      }

      // 获取当前月份
      let nowMonth = d.getMonth() + 1
      // 获取当前是几号
      let strDate = d.getDate()
      // 添加分隔符“-”
      // const seperator1 = "-"
      // 对月份进行处理，1-9月在前面添加一个“0”
      if (nowMonth >= 1 && nowMonth <= 9) {
        nowMonth = "0" + nowMonth
      }
      // 对日期进行处理，1-9号在前面添加一个“0”
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate
      }
      // 最后拼接字符串，得到一个格式为(yy-MM-dd HH:mm:ss)的日期
      // return d.getFullYear().toString().substr(2, 2) + seperator1 + nowMonth + seperator1 + strDate + '  ' + hour + seperator + minute + seperator + second
      return hour + seperator + minute + seperator + second
    },
    // 冒泡排序
    bubbleSort: function (arr) {
      let done  // 已经完成的标志位
      let len = arr.length
      for (let i = 0; i < len - 1; i++) {
        done = true
        for (let j = 0; j < len - 1 - i; j++) {
          if (arr[j].size > Number.MAX_VALUE || arr[j].size < -Number.MAX_VALUE) return "数值溢出！"
          if (arr[j].size > arr[j + 1].size) {
            [arr[j], arr[j + 1]] = [arr[j + 1], arr[j]]
            done = false
          }
        }
        if (done) {
          return arr
        }
      }
      return arr
    },
    // 格式化文件图标
    formatFileIcon(extension) {
      extension = extension.toLowerCase()
      let iconName = ''
      switch (extension) {
        case 'pptx':
        case 'ppt':
          iconName = '#icon-others-ppt'
          break
        case 'doc':
        case 'docx':
          iconName = '#icon-others-word'
          break
        case 'csv':
        case 'xls':
        case 'xlsx':
          iconName = '#icon-others-excel'
          break
        case 'pdf':
          iconName = '#icon-others-pdf'
          break
        case 'mp4':
        case 'm3u8':
        case 'rmvb':
        case 'avi':
        case 'swf':
        case '3gp':
        case 'mkv':
        case 'flv':
        case 'wmv':
        case 'f4v':
        case 'mov':
        case 'mpg':
        case 'mpeg':
        case 'vob':
        case 'rm':
        case 'm2ts':
        case 'web':
        case 'm4v':
        case 'ogv':
        case 'avchd':
        case 'webm':
          iconName = '#icon-others-video'
          break
        case 'mp3':
        case 'wav':
        case 'wma':
        case 'ogg':
        case 'aac':
        case 'flac':
        case 'mid':
        case 'm4a':
        case 'alac':
        case 'pcm':
        case 'aiff':
        case 'dts':
        case 'ar3':
        case 'amr':
        case 'au':
        case 'ape':
        case 'mka':
        case 'opus':
        case 'ra':
          iconName = '#icon-others-audio'
          break
        case 'gif':
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'bmp':
        case 'webp':
        case 'tif':
        case 'ico':
        case 'psd':
        case 'tiff':
        case 'tga':
        case 'dds':
        case 'svg':
        case 'indd':
        case 'eps':
        case 'hrd':
        case 'raw':
        case 'exr':
        case 'heic':
        case 'ai':
        case 'heif':
          iconName = '#icon-others-image'
          break
        case 'txt':
        case 'pages':
        case 'epub':
        case 'numbers':
        case 'keynote':
        case 'rtf':
        case 'ods':
        case 'odp':
        case 'odt':
        case 'wps':
        case 'xps':
        case 'oxps':
        case 'json':
        case 'mobi':
        case 'azw':
        case 'azw3':
        case 'caj':
          iconName = '#icon-others-text'
          break
        case 'rar':
        case 'zip':
        case '7z':
        case 'cab':
        case 'arj':
        case 'lzh':
        case 'tar':
        case 'gz':
        case 'ace':
        case 'uue':
        case 'bz2':
        case 'jar':
        case 'iso':
        case 'mpq':
          iconName = '#icon-others-zip'
          break
        default:
          iconName = '#icon-others-other'
      }
      return iconName
    },
    isText(suffix) {
      let textSuffix = ["pdf","ppt","pptx","doc","docx","xls","xlsx","csv","txt","rtf","ods","odp","odt","wps","xps","oxps","json","epub","mobi","azw","azw3","caj"];
      if (textSuffix.includes(suffix)){
        return true;
      }
      return false;
    },
    surpassFileSize(suffix, fileSize){
      if (this.isText(suffix)){
        if (fileSize > 100 * 1024 * 1024){
          return true;
        }
      }else {
        if (fileSize > 1024 * 1024 * 1024){
          return true;
        }
      }
      return false;
    }
  }
}
